import { AxiosInstance } from "axios";
import { createLogger } from "logging";
import { EntityActionResult } from "models/EntityActionResult";
import { PatchRunTopicModel } from "models/PatchRunTopicModel";

const logger = createLogger("RunTopicApi");

export class RunTopicApi {
  constructor(private axios: AxiosInstance) {}

  async addRunTopic(model: PatchRunTopicModel): Promise<EntityActionResult> {
    try {
      const response = await this.axios.post<EntityActionResult>(`/runtopics`, model, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      logger.error("Failed to add run topic", error);
      throw error;
    }
  }

  async updateRunTopic(id: string, model: PatchRunTopicModel): Promise<EntityActionResult> {
    try {
      const response = await this.axios.put<EntityActionResult>(`/runtopics/${id}`, model, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      logger.debug("updateRunTopic(): ", response);
      return response.data;
    } catch (error) {
      logger.error("Failed to update run topic", error);
      throw error;
    }
  }

  async deleteRunTopic(id: string): Promise<EntityActionResult> {
    try {
      const response = await this.axios.delete<EntityActionResult>(`/runtopics/${id}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to delete run topic", error);
      throw error;
    }
  }

  async reorderRunTopic(runId: string, oldIndex: number, newIndex: number): Promise<EntityActionResult> {
    try {
      const response = await this.axios.post<EntityActionResult>(`/runtopics/reorder/${runId}/${oldIndex}/${newIndex}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to reorder run topic", error);
      throw error;
    }
  }
}
